import React, { useState } from "react";
import { MdModeEditOutline } from "react-icons/md";
import image1 from "assets/img/profile/image1.png";
import image2 from "assets/img/profile/image2.png";
import image3 from "assets/img/profile/image3.png";
import Card from "components/card";
import Modal from "./SettingsModal";

const SettingsComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // Track modal state
  const [selectedItem, setSelectedItem] = useState(null); // Store the selected item

  const pages = [
    { id: 1, name: "Page 1", image: image1 },
    { id: 2, name: "Page 2", image: image3 },
    { id: 3, name: "Page 3", image: image2 }
  ];

  const openModal = (item) => {
    setSelectedItem(item); // Set the selected item
    setIsModalOpen(true); // Open the modal
  };

  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
    setSelectedItem(null); // Clear selected item
  };

  const handleSave = (updatedItem) => {
    // Implement your save logic here, e.g., update the page list or send data to the server
    console.log("Saved item:", updatedItem);
  };

  return (
    <Card extra={"w-full p-4 h-full"}>
      <div className="mb-8 w-full">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          All Pages Of Our Website
        </h4>
      </div>

      {pages.map((page) => (
        <div
          key={page.id}
          className="mt-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none"
        >
          <div className="flex items-center">
            <div>
              <img className="h-[83px] w-[83px] rounded-lg" src={page.image} alt={page.name} />
            </div>
            <div className="ml-4">
              <p className="text-base font-medium text-navy-700 dark:text-white">
                {page.name}
              </p>
            </div>
          </div>
          <button
            className="mr-4 flex items-center justify-center text-gray-600 hover:text-purple-800"
            onClick={() => openModal(page)} // Open the modal with the corresponding page
          >
            <MdModeEditOutline />
          </button>
        </div>
      ))}

      {/* Modal for editing */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        item={selectedItem || {}}
        onSave={handleSave}
      />
    </Card>
  );
};

export default SettingsComponent;
